(ns io.repliance.schemas.structured-analysis
  (:require [malli.util :as mu]
            [io.repliance.schemas.core :as schemas]))

(def Category
  [:map
   [:name :string]
   [:id :uuid]
   [:author :string]
   [:created schemas/Instant]])

(def StateDependencies
  "A map of state id of a dependency, to a state id, of this analysis"
  [:map-of :uuid :uuid])

(def States
  "A mapping of state id to display string, with a vector to maintain order"
  [:sequential
   [:tuple :uuid :string]])

(def NewAnalysisEvidence
  [:map
   [:evidence-id {:optional true} :int]
   [:provider {:optional true} [:maybe :string]]
   [:information-type {:optional true} [:maybe :string]]
   [:reference {:optional true} [:maybe :string]]
   [:comment {:optional true} [:maybe :string]]
   [:document-id [:maybe :uuid]]
   [:validated-by-automation [:maybe :string]]
   [:expiry-date {:optional true} [:maybe schemas/Instant]]
   [:expiry-action {:optional true} [:maybe :string]]
   [:evidence-type :string]
   [:content {:optional true} [:maybe :string]]
   [:created-ts {:optional true} [:maybe schemas/Instant]]
   [:content-data {:optional true} [:maybe :any]]
   [:control-status {:optional true} [:maybe :string]]
   [:responsible-org {:optional true} [:maybe :string]]
   [:responsible-team {:optional true} [:maybe :string]]
   [:responsible-person-id {:optional true} [:maybe :int]]
   [:responsible-person-revision {:optional true} [:maybe :int]]])

(def AnalysisEvidence
   (mu/merge
    NewAnalysisEvidence
    [:map
     [:evidence-id :int]
     [:ordinal :int]
     [:evidence-type :string]
     [:is-valid {:optional true} :boolean]
     [:content [:maybe :string]]
     [:content-data :any]
     [:content-data-hash :string]]))

(def StructuredAnalysis
  [:map
   [:construct-id :int]
   [:parent-id [:maybe :int]]

   [:structured-analysis-id
    {:doc "A counter that is incremented for each new structured analysis. Used for synchronization changes from master and for sorting in creation order."}
    :int]
   [:construct-version
    {:doc "A running number over the versions of structured analysis with this ID"}
    :int]
   [:version-id :uuid]
   [:next-version-id [:maybe :uuid]]
   [:previous-version-id [:maybe :uuid]]

   [:author :string]
   [:created schemas/Instant]

   [:construct :string]
   [:categories {:default []} [:sequential Category]]
   [:relates-to {:default []} [:sequential :string]]
   [:excludes {:default []} [:sequential :string]]
   [:comment [:maybe :string]]
   [:states {:default []} States]
   [:state-dependencies {:default {}} StateDependencies]])

(def AppliedStructuredAnalysisData
  [:map
   [:construct-id :int]
   [:construct-version :int]
   [:state-id [:uuid {:error/message "Please select state"}]]
   [:state-set-by [:enum "dependency" "this"]]
   [:product [:maybe :string]]
   [:answer-ids [:set :uuid]]])

(def AppliedStructuredAnalysis
  (mu/merge
    [:map
     [:structured-analysis-version-uuid :uuid]
     [:construct-id :int]
     [:construct-version :int]

     [:controls-met {:optional true} [:maybe :int]]
     [:evidence-count {:optional true} [:maybe :int]]
     [:invalid-evidence {:optional true} [:maybe :int]]

     [:applied-structured-analysis-id
      {:doc "A counter that is incremented for each new applied structured analysis. Used for sorting analyses in creation order."}
      :int]
     [:version
      {:doc "A running number over the versions of applied structured analysis, for the construct that the analysis corresponds to."}
      :int]
     [:version-id :uuid]
     [:next-version-id [:maybe :uuid]]
     [:previous-version-id [:maybe :uuid]]
     [:evidence-search-text {:optional true} [:maybe :string]]
     [:author :string]
     [:created schemas/Instant]]
    AppliedStructuredAnalysisData))


(def AppliedStructuredAnalysisWrite
  [:map [:state-evidence {:optional true} [:sequential [:maybe NewAnalysisEvidence]]]
        [:analyses [:sequential AppliedStructuredAnalysisData]]])